import { motion } from "framer-motion";

import { DEMO_QUESTIONS } from "../../lib/demoContent";
import { SceneCaption } from "./SceneCaption";

const Question = ({ q, baseDelay, label }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: baseDelay }}
    className="border border-[#DDD9CF] bg-white rounded-md p-6 xl:p-7"
  >
    <div className="text-[10px] uppercase tracking-[0.20em] text-[#C4521E] mb-3">
      {label}
    </div>
    <p className="text-lg xl:text-xl text-[#1A1814] font-serif-display leading-relaxed">
      {q.assistant}
    </p>

    <div className="mt-5 flex flex-wrap gap-2">
      {q.options.map((opt, i) => {
        const isSelected = opt === q.answered;
        const chipDelay = baseDelay + 0.6 + i * 0.12;
        const selectDelay = baseDelay + 0.6 + q.options.length * 0.12 + 0.4;
        return (
          <motion.span
            key={opt}
            initial={{ opacity: 0, y: 6 }}
            animate={
              isSelected
                ? {
                    opacity: 1,
                    y: 0,
                    backgroundColor: ["#FFFFFF", "#FFFFFF", "#C4521E"],
                    color: ["#1A1814", "#1A1814", "#F9F7F3"],
                    borderColor: ["#DDD9CF", "#DDD9CF", "#C4521E"],
                  }
                : { opacity: 1, y: 0 }
            }
            transition={
              isSelected
                ? {
                    opacity: { duration: 0.4, delay: chipDelay },
                    y: { duration: 0.4, delay: chipDelay },
                    backgroundColor: { duration: 0.5, delay: selectDelay },
                    color: { duration: 0.5, delay: selectDelay },
                    borderColor: { duration: 0.5, delay: selectDelay },
                  }
                : { duration: 0.4, delay: chipDelay }
            }
            className="text-sm px-4 py-2 border rounded-full"
            style={{
              borderColor: "#DDD9CF",
              color: "#1A1814",
              backgroundColor: "#FFFFFF",
            }}
          >
            {opt}
          </motion.span>
        );
      })}
    </div>
  </motion.div>
);

/** Scene 4 — the two questions. Chips appear, one fills with terracotta. */
export const ScreenQuestions = () => (
  <div className="max-w-3xl" data-testid="demo-scene-questions">
    <SceneCaption eyebrow="The questions" body="It asked her two questions." />

    <div className="mt-6 space-y-5">
      <Question q={DEMO_QUESTIONS[0]} baseDelay={0.8} label="Question 1 of 2" />
      <Question q={DEMO_QUESTIONS[1]} baseDelay={5.0} label="Question 2 of 2" />
    </div>

    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 11.0 }}
      className="mt-6 border border-[#DDD9CF] bg-white rounded-md px-6 py-5 xl:px-7 xl:py-6"
    >
      <p className="font-serif-display italic text-lg xl:text-xl text-[#1A1814] leading-relaxed">
        That was enough.
      </p>
    </motion.div>
  </div>
);
